export default __webpack_public_path__ + "static/media/Residency Visa - Home Page.1697c5f1.jpg";